import axios from 'axios';
import KeycloakService from './KeycloakService';
import { API_INTERNAL_BASE_URL, API_TIMEOUT } from '../config/api';

class MentorCourseApiService {
  /**
   * Lấy danh sách course được assign cho mentor (có phân trang, search)
   * @param {Object} params { page, pageSize, search }
   * @param {string} [baseURL] - Cho phép truyền baseURL động (nếu cần)
   */
  getMentorCourses = async ({ page = 1, pageSize = 10, search = "", status } = {}, baseURL = API_INTERNAL_BASE_URL) => {
    const token = KeycloakService.getToken();
    const axiosInstance = axios.create({
      baseURL: baseURL,
      timeout: API_TIMEOUT,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
    });
    const params = {
      page,
      limit: pageSize, 
      search: search.trim(),
    };
    if (status && status !== 'all') params.status = status;
    const response = await axiosInstance.get('/courses', {
      params,
    });
    return {
      courses: response.data?.data?.courses?.map(course => ({ ...course, key: course._id })) || [],
      pagination: response.data?.data?.pagination || {},
    };
  };

  /**
   * Lấy chi tiết course cho mentor theo slug (dùng cho màn learning zone)
   * @param {string} courseSlug
   * @returns {Promise<object>} course detail
   */
  getMentorCourseDetailBySlug = async (courseSlug, baseURL = API_INTERNAL_BASE_URL) => {
    const token = KeycloakService.getToken();
    const axiosInstance = axios.create({
      baseURL: baseURL,
      timeout: API_TIMEOUT,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
    });
    const response = await axiosInstance.get(`/courses/slug/${courseSlug}`);
    return response.data;
  };

  /**
   * Lấy chi tiết lesson cho mentor
   * @param {string} lessonId
   * @returns {Promise<object>} lesson detail
   */
  getMentorLessonDetailById = async (lessonId, baseURL = API_INTERNAL_BASE_URL) => {
    const token = KeycloakService.getToken();
    const axiosInstance = axios.create({
      baseURL: baseURL,
      timeout: API_TIMEOUT,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
    });
    const response = await axiosInstance.get(`/lessons/${lessonId}`);
    return response.data;
  };

  /**
   * Lấy signedUrl video lesson cho mentor
   * @param {string} lessonId
   * @returns {Promise<object>} video url
   */
  getMentorLessonVideoUrl = async (lessonId, baseURL = API_INTERNAL_BASE_URL) => {
    const token = KeycloakService.getToken();
    const axiosInstance = axios.create({
      baseURL: baseURL,
      timeout: API_TIMEOUT,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
    });
    const response = await axiosInstance.get(`/lessons/${lessonId}/video-stream-url`);
    return response.data;
  };
}

export default new MentorCourseApiService(); 